import { IonButton, IonContent, IonIcon, IonPopover } from "@ionic/react";
import "./UserButton.css";
import { personOutline } from "ionicons/icons";

interface UserButtonProps {}

const UserButton: React.FC<UserButtonProps> = ({}) => {
  return (
    <>
      <IonButton id="click-trigger" shape="round" className="UserButton">
        <IonIcon slot="icon-only" icon={personOutline} />
      </IonButton>
      <IonPopover trigger="click-trigger" triggerAction="click">
        <IonContent class="ion-padding">Hello World!</IonContent>
      </IonPopover>
    </>
  );
};

export default UserButton;
